import React from 'react';
import '../styles/blog.css';

const blogMonths = [
  { id: 'enero', label: 'Enero 2025', image: 'blog-enero-2025.png' },
  { id: 'febrero', label: 'Febrero 2025', image: 'blog-febrero-2025.png' },
  { id: 'marzo', label: 'Marzo 2025', image: 'blog-marzo-2025.png' },
  { id: 'abril', label: 'Abril 2025', image: 'blog-abril-2025.png' },
  { id: 'mayo', label: 'Mayo 2025', image: 'blog-mayo-2025.png' },
  { id: 'junio', label: 'Junio 2025', image: 'blog-junio-2025.png' },
  { id: 'julio', label: 'Julio 2025', image: 'blog-julio-2025.png' },
  { id: 'agosto', label: 'Agosto 2025', image: 'blog-agosto-2025.png' },
  { id: 'septiembre', label: 'Septiembre 2025', image: 'blog-septiembre-2025.png' },
  { id: 'octubre', label: 'Octubre 2025', image: 'blog-octubre-2025.png' },
  { id: 'noviembre', label: 'Noviembre 2025', image: 'blog-noviembre-2025.png' },
  { id: 'diciembre', label: 'Diciembre 2025', image: 'blog-diciembre-2025.png' },
];

const BlogPage = () => {
  return (
    <div className="blog-root">
      <section className="blog-section blog-section-intro">
        <div className="blog-hero-card">
          <h1 className="blog-hero-title">Informativos</h1>
          <p className="blog-hero-text">
            Nuestro programa ofrece una gama especializada de terapias, talleres y cursos diseñados
            específicamente. Cada actividad está cuidadosamente planificada para potenciar sus capacidades
            únicas, fomentar su desarrollo integral y fortalecer sus habilidades de comunicación, regulación
            emocional e interacción social. Trabajamos en un entorno de apoyo inclusivo que valora la
            diversidad neuronal, utilizando metodologías adaptadas que se ajustan a las necesidades
            individuales, en colaboración estrecha con las familias para garantizar un apoyo coherente y
            significativo en su día a día.
          </p>
        </div>
      </section>

      <section className="blog-section blog-section-archive">
        <div className="blog-months-grid">
          {blogMonths.map((month) => (
            <article key={month.id} className="blog-month-card">
              <div className="blog-month-header">
                <h2 className="blog-month-title">{month.label}</h2>
                <a href={`#${month.id}`} className="blog-month-link">
                  Ver Fotos &gt;
                </a>
              </div>
              <div className="blog-month-visual">
                <img
                  src={`${process.env.PUBLIC_URL}/images/${month.image}`}
                  alt={`Fotos de ${month.label}`}
                  className="blog-month-photo"
                />
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
